import React from 'react'
import { connect } from 'react-redux'
import SearchBar from "material-ui-search-bar";
import { Grid, Button, Menu, MenuItem, Typography, Hidden, Badge } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { red, green, grey } from '@material-ui/core/colors';
import { setSearchText, setFoodPrefrence } from '../../actions/metaAction'

import { debounce } from 'lodash'

const colors = {
    ALL: grey[500],
    VEG: green[600],
    NON_VEG: red[600],
    CONTAINS_EGG: '#96503a'
}

const text = {
    ALL: 'all',
    VEG: 'veg',
    NON_VEG: 'non veg',
    CONTAINS_EGG: 'eggs'
}

const useStyles = makeStyles((theme) => ({
    cuisine: {
        '&  div': {
            borderRadius: '1000px'
        }
    },
    markDiv: {
        position: "relative"
    },
    mark: {
        padding: "0 0 0 20px",
        position: "relative",
        lineHeight: "2",
        color: "#a8a8a8",
        textTransform: "uppercase",
        '&::before': {
            content: '" "',
            position: "absolute",
            width: "14px",
            height: "14px",
            boxSizing: "border-box",
            border: (props) => (`1px solid ${colors[props.value]}`),
            borderRadius: "2px",
            left: "0",
            top: "8px",
        },
        '&::after': {
            content: '" "',
            position: "absolute",
            width: "6px",
            height: "6px",
            boxSizing: "border-box",
            background: (props) => colors[props.value],
            borderRadius: "50%",
            left: "4px",
            top: "12px"
        }
    },
    border: {
        fontFamily: 'inherit',
        '& > * > ul': {
            border: '1px solid #e2e2e2'
        }
    },
    menuItem: {
        border: '1px solid #fafafa',
        borderBottom: '0'
        // borderRadius: '1000px'
    },
    anchor: {
        display: "block",
        position: "relative",
        [theme.breakpoints.down("xs")]: {
            top: "-130px",
        },
        top: "-80px",
        visibility: "hidden",
    },
    searchBar: {
        boxSizing: "border-box",
        height: '45px',
        border: `1px solid ${grey[500]}`,
        borderRadius: '1000px'
    },
    buttonDiv: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    smallScreen: {
        [theme.breakpoints.down("xs")]: {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& >*': {
            marginRight: theme.spacing(1)
        }
    }
}));

const MenuItemComponent = (props) => {
    const classes = useStyles(props)
    const { label } = props
    return (
        <div className={classes.markDiv}>
            <div className={classes.mark}><Typography component="span" variant="body1" color="primary" >{label}</Typography> </div>
        </div>
    )
}

const FilterBar = (props) => {
    const [value, setValue] = React.useState('')
    const [anchorEl, setAnchorEl] = React.useState(null)

    function onMenuClose() {
        setAnchorEl(null)
    }

    function onMenuOpen(e) {
        setAnchorEl(e.target)
    }

    const classes = useStyles();

    React.useEffect(() => {
        setValue(props.searchText)
    }, [])

    function onChange(newValue) {

        setValue(newValue)

        const debouncedSetSearchText = debounce(() => props.setSearchText(newValue), 500)

        debouncedSetSearchText()

    }

    function onRequestSearch() {

        const debouncedSetSearchText = debounce(() => props.setSearchText(value), 500)

        debouncedSetSearchText()
    }

    function onCancelSearch() {
        setValue('')
        const debouncedSetSearchText = debounce(() => props.setSearchText(''), 500)

        debouncedSetSearchText()
    }

    const items = [
        {
            value: 'ALL',
            label: 'All Prefrences'
        },
        {
            value: 'VEG',
            label: 'Pure Veg'
        },
        {
            value: 'NON_VEG',
            label: 'Non Veg'
        },
        {
            value: 'CONTAINS_EGG',
            label: 'Contains Egg'
        }
    ]

    return (
        <div>
            <div className={classes.anchor} id="search"></div>
            <Grid container spacing={2} className={classes.smallScreen} >
                <Grid item xs={9} sm={10}>
                    <SearchBar
                        className={classes.searchBar}
                        value={value}
                        placeholder="Type to Search"
                        onChange={(newValue) => onChange(newValue)}
                        onRequestSearch={onRequestSearch}
                        onCancelSearch={onCancelSearch}
                    />
                </Grid>
                <Grid item xs={3} sm={2} className={classes.buttonDiv} >
                    <Badge color="primary" overlap="circle" badgeContent={text[props.foodPref]} anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }} >
                        <Button color="primary" variant="outlined" size="large" startIcon={<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-filter" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#272727" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5" />
                        </svg>} onClick={onMenuOpen}> <Hidden smDown>Filters</Hidden> </Button>
                    </Badge>
                    <Menu
                        className={classes.border}
                        id="filters"
                        elevation={4}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={onMenuClose}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        {
                            items.map(item => {
                                return (
                                    <MenuItem key={item.value} value={item.value} className={classes.menuItem} onClick={() => {
                                        onMenuClose()
                                        props.setFoodPrefrence(item.value)
                                    }}>
                                        <MenuItemComponent value={item.value} label={item.label} />
                                    </MenuItem>
                                )
                            })
                        }
                    </Menu>
                </Grid>
            </Grid>
        </div>

    )

}

const mapStateToProps = (state) => {
    return {
        searchText: state.meta.searchText,
        foodPref: state.meta.foodPref
    }
}

export default connect(mapStateToProps, { setSearchText, setFoodPrefrence })(FilterBar)